import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { enlazarApp } from "../services/app.service";

import { successNotification, dangerNotification } from '../../../redux/slices/ui';

export const useEnlazarApp = (id) => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const enlazarAppMutation = useMutation({
        mutationFn: enlazarApp,
        onSuccess: (cita, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ['resumenPaciente', id] });
            dispatch(successNotification('App enlazada'));
        },
        onError: (error, variables, context) => {
            variables.onComplete();
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        enlazarAppMutation,
    }
}